<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約状況検索条件の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約状況検索条件の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/select-reservation-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png">閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png">検索条件
        </div>
        <div class="manual-explain">
          属性：<br>
          予約施設の属性を選択します。属性を選択した場合は予約番号は未設定となります。<br>
          予約施設ID：<br>
          予約施設IDを設定します。右のルーペアイコンをクリックすると予約施設一覧ダイアログを表示し、予約施設を検索することができます。予約施設IDを設定した場合は予約番号は未設定となります。<br>
          利用日：開始日 - 終了日：<br>
          予約の利用日を範囲で設定します。利用日を設定した場合は予約番号は未設定となります。<br>
          予約状況：<br>
          予約状況を選択します。予約状況を選択した場合は予約番号は未設定となります。<br>
          予約番号：<br>
          予約番号を設定します。予約番号を設定した場合は他の条件は未設定となります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png">検索ボタン
        </div>
        <div class="manual-explain">
          検索条件に設定された内容で予約情報を検索します。<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Status Search Criteria
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Status Search Criteria</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_select-reservation-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Search Criteria
        </div>
        <div class="manual-explain">
          Attribute:<br>
          Select the attribute of the reservation facility. When an attribute is selected, the reservation number will be unset.<br>
          Reservation Facility ID:<br>
          Set the reservation facility ID. Click the magnifying glass icon on the right to display the reservation facility list dialog and search for reservation facilities. When a reservation facility ID is set, the reservation number will be unset.<br>
          Usage Date: Start Date - End Date:<br>
          Set the usage date of the reservation as a range. When a usage date is set, the reservation number will be unset.<br>
          Reservation Status:<br>
          Select the reservation status. When a reservation status is selected, the reservation number will be unset.<br>
          Reservation Number:<br>
          Set the reservation number. When a reservation number is set, other conditions will be unset.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Search Button
        </div>
        <div class="manual-explain">
          Search for reservation information based on the criteria set in the search conditions.<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
